import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { Capacitor } from '@capacitor/core';

const NetworkContext = createContext({ online: true });

export const useNetwork = () => useContext(NetworkContext);

export function NetworkProvider({ children }) {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return (
    <NetworkContext.Provider value={{ online }}>
      {children}
    </NetworkContext.Provider>
  );
}

/**
 * Hook that wraps an async action with network check.
 * Shows a toast if offline and returns null instead of executing.
 */
export function useNetworkGuard() {
  const { online } = useNetwork();

  const guard = useCallback((action, label) => {
    if (!online) {
      const { toast } = require('sonner');
      toast.error(`Internet required for ${label}.`, { id: `offline-${label}` });
      return null;
    }
    return action();
  }, [online]);

  return { online, guard };
}


